
<template>
  <v-layout 
    column>
    <section 
      :class="$vuetify.breakpoint.name === 'xl' ? 'container' : ''">
      <v-container>
        <v-row 
          justify="center" 
          align="center" 
          :style="token ? 'min-height: 77.6vh;' : 'min-height: 100vh;'">
          <v-col 
            cols="12" 
            md="6">
            <v-card 
              flat 
              class="border-radius pa-12">
              <v-row 
                justify="center" 
                align="center">
                <v-col 
                  cols="12" 
                  md="10">
                  <div 
                    class="mb-12">
                    <v-img 
                      alt="vuetify" 
                      :src="require('@/assets/image/404.png')"
                      max-height="175"
                      max-width="175"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#0786BE">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>

                  <div 
                    class="text-center">
                    <div 
                      class="title text-first font-weight-bold my-6">
                      Halaman Tidak Ditemukan
                    </div>

                    <div 
                      class="body-1 font-weight-light text-second line-text-second pb-12">
                      Sepertinya halaman yang Anda tuju tidak terdaftar dalam website kami.
                    </div>

                    <v-btn
                      light
                      large
                      rounded
                      :color="set_color"
                      elevation="0"
                      class="body-1 font-weight-bold white--text text-capitalize"
                      to="/">
                      <v-icon x-large>mdi-pan-left</v-icon>
                      
                      Halaman Utama
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-layout>
</template>

<script>
  export default {
    computed: {
      token () {
        return this.$store.state.token
      },
      set_color () {
        return this.$store.state.color
      }
    }
  }
</script>